import { render, staticRenderFns } from "./SuggestionsAnswerComponent.vue?vue&type=template&id=5b759ed7&scoped=true&"
import script from "./SuggestionsAnswerComponent.vue?vue&type=script&lang=ts&"
export * from "./SuggestionsAnswerComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b759ed7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VChip,VChipGroup})
